import { render } from "./choose-sku.vue?vue&type=template&id=af473b28&scoped=true&ts=true"
import script from "./choose-sku.vue?vue&type=script&lang=ts"
export * from "./choose-sku.vue?vue&type=script&lang=ts"

import "./choose-sku.vue?vue&type=style&index=0&id=af473b28&scoped=true&lang=scss"
import "./choose-sku.vue?vue&type=style&index=1&id=af473b28&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af473b28"]])

export default __exports__